<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Attendance Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" sm="2" md="2">
                    Date Wise
                    <v-switch color="brand" @change="
              semester_wise = false;
              month_wise = false;
              sel_ay_data = null;
              sel_std_data = null;
              division_offering = null;
              div_list = null;
              std_div_list = null;
            " v-model="date_wise"></v-switch>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    Month Wise
                    <v-switch color="brand" @change="
              date_wise = false;
              semester_wise = false;
              sel_ay_data = null;
              sel_std_data = null;
              division_offering = null;
              div_list = null;
              std_div_list = null;
            " v-model="month_wise"></v-switch>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    Semester Wise
                    <v-switch color="brand" @change="
              date_wise = false;
              month_wise = false;
              sel_ay_data = null;
              sel_std_data = null;
              division_offering = null;
              div_list = null;
              std_div_list = null;
            " v-model="semester_wise"></v-switch>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="date_wise">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Date Wise Attendance Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Select Standard" outlined @change="getDiv"
                        persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Select Division" outlined persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="6" md="6" v-if="div != null">
                    <v-icon color="error">*</v-icon>
                    From Date ::
                    <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                    <v-icon color="error" class="ml-3">*</v-icon>
                    To Date ::
                    <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
                </v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-btn @click="getAttendanceReport()" :disabled="fromdate == null || todate == null"
                    :loading="fetch_loader" class="button mt-7 pt-0">Generate Report</v-btn>
            </v-row>
            <v-card v-if="day_attendance != ''">
                <v-row dense>
                    <v-col cols="12" sm="6" md="6">
                        <v-btn rounded color="success" outlined @click="
                fnExcelReport('my-table-id', 'DateWiseAttendendanceReport')
              " :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <!-- search code shiv -->
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search1" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="">Admission Year</th>
                                    <th class="">Total Working Days (AP)</th>
                                    <th class="">Total Working Days Of Student</th>
                                    <th class="">Total Present</th>
                                    <th class="">Total Absent</th>
                                    <th class="">Percentage</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <!-- search func -->
                                <tr v-for="(s, index1) in filteredItems" :key="s.id">
                                    <!-- <tr v-for="(s, index1) in day_attendance" :key="s.id"> -->

                                    <td>{{ index1 + 1 }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.division }}</td>
                                    <td>{{ s.learner_addmission_year }}</td>

                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.total_working_days_sem }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.total_working_stud }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.present }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.absent }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.percentage }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </v-card>
        </v-card>
        <v-card class="box" v-if="month_wise">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Month Wise Attendance Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Select Standard" outlined @change="getDiv"
                        persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Select Division" outlined persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                        item-text="name" item-value="name" label="Select Year" outlined persistent-hint
                        hint="Please Select Year" />
                </v-col>
                <v-col cols="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="month" :items="month_list"
                        item-text="name" item-value="id" label="Select Month" outlined persistent-hint
                        hint="Please Select Month" multiple />
                </v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-btn @click="getAttendanceReport()" :disabled="year == null || month == null" :loading="fetch_loader"
                    class="button mt-7 pt-0">Generate Report</v-btn>
            </v-row>
            <v-card v-if="month_attendance != ''">
                <v-row dense>
                    <v-col cols="12" sm="6" md="6">
                        <v-btn rounded color="success" outlined @click="
                fnExcelReport('my-table-id', 'MonthWiseAttendendanceReport')
              " :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <!-- search code shiv -->
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search1" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="">Admission Year</th>
                                    <th class="">Total Working Days (AP)</th>
                                    <th class="">Total Working Days Of Student</th>
                                    <th class="">Total Present</th>
                                    <th class="">Total Absent</th>
                                    <th class="">Percentage</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <!-- search func -->
                                <tr v-for="(s, index1) in filteredItems1" :key="s.id">
                                    <!-- <tr v-for="(s, index1) in month_attendance" :key="s.id"> -->
                                    <td>{{ index1 + 1 }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.division }}</td>
                                    <td>{{ s.learner_addmission_year }}</td>

                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.total_working_days_sem }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.total_working_stud }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.present }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.absent }}
                                    </td>
                                    <td v-for="(a, index) in s.attendance" :key="index">
                                        {{ a.percentage }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6">Total Details</td>
                                    <td>{{ total_details.total_working_days_sem }}</td>
                                    <td>{{ total_details.total_working_stud }}</td>
                                    <td>{{ total_details.present }}</td>
                                    <td>{{ total_details.absent }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </v-card>
        </v-card>
        <v-card class="box" v-if="semester_wise">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Semester Wise Attendance Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Select Standard" outlined @change="getDiv"
                        persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Select Division" outlined persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
                        item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-btn @click="getAttendanceReport()" :disabled="sem == null" :loading="fetch_loader"
                    class="button mt-7 pt-0">Generate Report</v-btn>
            </v-row>
            <v-card v-if="semester_attendance != ''">
                <v-row dense>
                    <v-col cols="12" sm="6" md="6">
                        <v-btn rounded color="success" outlined @click="
                fnExcelReport('my-table-id', 'SemesterWiseAttendendanceReport')
              " :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <!-- search code shiv -->
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search1" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="">Admission Year</th>

                                    <th class="">Total Working Days (AP)</th>
                                    <th class="">Total Working Days Of Student</th>
                                    <th class="">Total Present</th>
                                    <th class="">Total Absent</th>
                                    <th class="">percentage</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <!-- search func -->
                                <tr v-for="(s, index1) in filteredItems2" :key="index1">
                                    <!-- <tr v-for="(s, index1) in semester_attendance" :key="s.id"> -->
                                    <td>{{ index1 + 1 }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.division }}</td>
                                    <td>{{ s.learner_addmission_year }}</td>

                                    <td v-for="(a, index2) in s.attendance" :key="index2">
                                        {{ a.total_working_days_sem }}
                                    </td>
                                    <td v-for="(a, index3) in s.attendance" :key="index3">
                                        {{ a.total_working_stud }}
                                    </td>
                                    <td v-for="(a, index4) in s.attendance" :key="index4">
                                        {{ a.present }}
                                    </td>
                                    <td v-for="(a, index5) in s.attendance" :key="index5">
                                        {{ a.absent }}
                                    </td>
                                    <td v-for="(a, index6) in s.attendance" :key="index6">
                                        {{ a.percentage}}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </v-card>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },

        data() {
            return {
                snackbar_msg: "",
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                date_wise: false,
                month_wise: false,
                semester_wise: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                fromdate: null,
                todate: null,
                semester_list: [],
                total_details: null,
                sem: null,
                month: null,
                year: null,
                fetch_loader: false,
                loader: false,
                year_list: [
                    { name: "2021", id: "1" },
                    { name: "2022", id: "2" },
                    { name: "2023", id: "3" },
                    { name: "2024", id: "4" },
                    { name: "2025", id: "5" },
                    { name: "2026", id: "6" },
                ],
                month_list: [
                    { name: "January", id: "1", month_number: "1" },
                    { name: "February", id: "2", month_number: "2" },
                    { name: "March", id: "3", month_number: "3" },
                    { name: "April", id: "4", month_number: "4" },
                    { name: "May", id: "5", month_number: "5" },
                    { name: "June ", id: "6", month_number: "6" },
                    { name: "July", id: "7", month_number: "7" },
                    { name: "August", id: "8", month_number: "8" },
                    { name: "September", id: "9", month_number: "9" },
                    { name: "October", id: "10", month_number: "10" },
                    { name: "November", id: "11", month_number: "11" },
                    { name: "December", id: "12", month_number: "12" },
                ],
                day_attendance: [],
                month_attendance: [],
                semester_attendance: [],
                search1: "",
                status_list: [],
                stud_status: '',
            };
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            getAttendanceReport() {
                const data = {
                    month: this.date,
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division_offering: this.div,
                    months: this.month,
                    year: this.year,
                    semester: this.sem,
                    fromdate: this.fromdate,
                    todate: this.todate,
                    date_wise: this.date_wise,
                    month_wise: this.month_wise,
                    semester_wise: this.semester_wise,
                    status: this.stud_status.id
                };
                this.fetch_loader = true;
                axios
                    .post("/Academics/getAttendanceReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.day_attendance = res.data.day_attendance;
                            if (this.month_wise == true) {
                                this.total_details = res.data.total_details
                            }
                            (this.month_attendance = res.data.month_attendance), (this.semester_attendance = res.data.semester_attendance);
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //this.sel_ay_data = res.data.curr_ay;
                        this.semester_list = res.data.sem_list;
                        this.status_list = res.data.status_list;
                        this.stud_status = this.status_list[1];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
            },
        },
        computed: {
            filteredItems() {
                return this.day_attendance.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search1.toLowerCase()) > -1;
                });
            },
            filteredItems1() {
                return this.month_attendance.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search1.toLowerCase()) > -1;
                });
            },
            filteredItems2() {
                return this.semester_attendance.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search1.toLowerCase()) > -1;
                });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }

    .text-color {
        font-weight: bold;
        color: red;
    }

    .scroll {
        overflow-x: scroll;
    }

    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }

    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }

    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }

    @media (min-width: 320px) {

        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td+td,
        th+th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>